export function Logo({ className = "h-9 w-auto" }) {
  return <img src="/kera-logo.webp" alt="KERA — From God's Own Country" className={className} />;
}
